import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      fontSize: theme.typography.pxToRem(14),
    },
    boldLabel: {},
    grayDescription: {},
    boldDescription: {},

    label: {
      color: theme.palette.text.primary,

      '$boldLabel &': {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
    separator: {
      margin: theme.spacing(0, 0.5),
    },
    description: {
      color: theme.palette.text.primary,

      '$grayDescription &': {
        color: COLORS.gray.gray40,
      },
      '$boldDescription &': {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
  }),
  { name: 'GenerationToolLabel' }
);
